import { useEffect, useState } from "react"

export function useAfterEffect(callback, dependencies) {
  const [isFirst, setIsFirst] = useState(true)

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useEffect(() => isFirst ? setIsFirst(false) : callback(), dependencies)
}
